import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

interface SEOHeadProps {
  title: string;
  description: string;
  keywords?: string;
  canonicalUrl?: string;
  ogType?: 'website' | 'article';
  ogImage?: string;
  ogImageWidth?: number;
  ogImageHeight?: number;
  publishDate?: string;
  updateDate?: string;
}

export default function SEOHead({
  title,
  description,
  keywords = 'po文推荐,po文推荐清单,热门po文推荐,高质量po文推荐,今日po文推荐,必看po文推荐,po文精选合集',
  canonicalUrl = 'https://powen-tuijian.com',
  ogType = 'website',
  ogImage,
  ogImageWidth = 1200,
  ogImageHeight = 630,
  publishDate,
  updateDate,
}: SEOHeadProps) {
  const location = useLocation();

  useEffect(() => {
    const fullTitle = title.includes('po文推荐') ? title : `${title} - po文推荐`;

    document.title = fullTitle;

    const setMeta = (name: string, content: string, isProperty = false) => {
      const attr = isProperty ? 'property' : 'name';
      let el = document.querySelector(`meta[${attr}="${name}"]`) as HTMLMetaElement | null;
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute(attr, name);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    };

    const setLink = (rel: string, href: string) => {
      let el = document.querySelector(`link[rel="${rel}"]`) as HTMLLinkElement | null;
      if (!el) {
        el = document.createElement('link');
        el.setAttribute('rel', rel);
        document.head.appendChild(el);
      }
      el.setAttribute('href', href);
    };

    setMeta('description', description);
    setLink('canonical', canonicalUrl);

    setMeta('og:type', ogType, true);
    setMeta('og:title', fullTitle, true);
    setMeta('og:description', description, true);
    setMeta('og:url', canonicalUrl, true);
    setMeta('og:site_name', 'po文推荐', true);
    setMeta('og:locale', 'zh_CN', true);
    if (ogImage) {
      setMeta('og:image', ogImage, true);
      setMeta('og:image:width', String(ogImageWidth), true);
      setMeta('og:image:height', String(ogImageHeight), true);
    }

    setMeta('twitter:card', 'summary_large_image');
    setMeta('twitter:title', fullTitle);
    setMeta('twitter:description', description);
    if (ogImage) {
      setMeta('twitter:image', ogImage);
    }

    if (publishDate) setMeta('article:published_time', publishDate, true);
    if (updateDate) setMeta('article:modified_time', updateDate, true);
  }, [title, description, keywords, canonicalUrl, ogType, ogImage, ogImageWidth, ogImageHeight, publishDate, updateDate, location.pathname]);

  return null;
}